export default class AdBlockDetector {
  static hasAdBlocker() {
    const img = document.querySelector('.ads img');
    if (img) {
      return window.getComputedStyle(img, null).display === "none";
    } else {
      return true;
    }
  }
}
